module.exports = __webpack_public_path__ + "static/fowler-7865c29b4dbb374e03476fb78b33436e.jpg";